import { styled } from '@/stitches.config';
import { Box } from '@/common/components';

export const StyledInfoPanel = styled(Box, {
  alignItems: 'flex-end',
  display: 'flex',
  gap: '$6',
  flexDirection: 'column',
  justifyContent: 'space-between',
});
